import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import { Map } from 'immutable';
import TeamEventListActions from 'flux/actions/TeamEventListActions';
import TeamActions from 'flux/actions/TeamActions';
import EventFormActions from 'flux/actions/EventFormActions';
import EventListActions from 'flux/actions/EventListActions';
import EventListMixin from 'flux/stores/EventListMixin';
import PaginationMixin from 'flux/stores/PaginationMixin';
import RealTimeActions from 'flux/actions/RealTimeActions';
import ToastActions from 'flux/actions/ToastActions';
import EventFilterStore from 'flux/stores/EventFilterStore';

const duplicateEventCompleted = EventListActions.duplicate.completed,
  restoreEventCompleted = EventListActions.restore.completed,
  softDeleteEventCompleted = EventListActions.softDelete.completed,
  saveEventCompleted = EventFormActions.save.completed;

/**
 * TeamEventListStore
 *
 * Maintain team event list state
 *
 */
export default Reflux.createStore({
  listenables: [
    TeamEventListActions,
    EventListActions,
    RealTimeActions,
    TeamActions,
  ],

  mixins: [BaseMixin, EventListMixin, PaginationMixin],

  init() {
    this.listenTo(duplicateEventCompleted, this.triggerToastSuccess);
    this.listenTo(restoreEventCompleted, this.triggerToastSuccess);
    this.listenTo(softDeleteEventCompleted, this.triggerToastSuccess);
    this.listenTo(saveEventCompleted, this.triggerToastSuccess);

    EventFilterStore.listen(this.onFilterChange);

    this.setState(Map({}));
  },

  onFilterChange(storeState) {
    let next = this.getState()
      .set('filterQuery', storeState.get('query'))
      .set('activeType', storeState.get('activeType')); //Event Type - PAST, UPCOMING, etc.

    this.setState(next);

    TeamEventListActions.notifyFilterChange(); //Used to trigger spinner
    TeamEventListActions.page(1);
  },

  onEventCreatedRealTime(teamId, event) {
    if (this.getState().hasIn(['all', teamId])) return;

    this.appendNew(event);
  },

  onPopulate(teamId) {
    let next = this.getState().set('teamId', teamId);

    this.setState(next);

    RealTimeActions.subscribeToTeam(teamId);
  },

  onGetPageCompleted(page) {
    let next = this.populatePaginationState(page);

    this.setStateAndTrigger(next);

    this._subscribeToEvents();
  },

  triggerToastSuccess() {
    ToastActions.success('Success');
  },
});
